import React from 'react';
import Category from '../../Components/Category/Category';
import CategoryCard from '../../Components/CategoryCard/CategoryCard';
import MainCard from '../../Components/MainCard/MainCard';
import FeaturedProduct from '../../Components/FeaturedProduct/FeaturedProduct';
import Header from '../../Components/Header/Header';
import HeaderLower from '../../Components/HeaderLower/HeaderLower';
import saleLogo from '../../assets/banner-HOTWEEK-categorias-02.gif';
import saleLogoMobile from '../../assets/mobile-HOTWEEK-categoria-02.gif';

export default function Ofertas() {

    return (
        <div>
            <Header />
            <HeaderLower />
            <Category title={`Hot Week`} img={saleLogo} imgMobile={saleLogoMobile} />
            <CategoryCard title={`Hot Week`} />
            <MainCard category={'HOT WEEK'} promo={true} />
            <FeaturedProduct />
        </div>
    )
}
